import React from 'react'
import { Outlet } from 'react-router-dom'

function SubAdmin() {
  return (
    <Outlet/>
  )
}

export default SubAdmin